<template>
  <b-row>
    <b-col sm="12">

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Rendición de Cobranzas</h4>
            <div class="small text-muted">Administración de todas mis rendiciones de cobranzas enviadas.</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="$router.push({ name: 'ReportsPaymentStaffMobileSurrenderCreate' })"
                      type="button" variant="success" size="sm" class="btn-pill float-right ml-2"
                      v-b-tooltip.hover title="Rendir cobranzas">
              <b-icon icon="plus"></b-icon> Nueva rendición
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="12">
            <b-row>
              <b-col md="2" class="pr-0">
                <b-form-input type="date" size="md" v-model="filter.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="2" class="pl-0">
                <b-form-input type="date" size="md" v-model="filter.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>
              <b-col sm="2">
                <v-select :options="arr.filter.status" v-model="filter.status" placeholder="Estado" :multiple="false" :select-on-tab="true"></v-select>
              </b-col>
              <b-col sm="2">
                <b-button variant="outline-dark" @click="filterReport()">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="formartedItems"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    selectable
                    select-mode="single"
                    @row-selected="onRowSelected"
                    v-if="table.items.length">

                <template v-slot:row-details="row">
                  <b-card>
                    <b-row>
                      <b-col>
                        <div class="product-line-titulo-subline mb-2">
                          <b>Detalle Rendición Nº:</b> {{row.item.id}}
                        </div>
                        <b-table class="mb-0"
                                responsive="sm"
                                head-variant="dark"
                                :hover="true"
                                :small="true"
                                :fixed="false"
                                :items="tableSub.items"
                                :fields="tableSub.fields"
                                v-if="tableSub.items.length">

                          <template v-slot:cell(id)="row">
                            <b>{{row.item.reports_payment.id}}</b>
                          </template>

                          <template v-slot:cell(date)="row">
                            {{moment(row.item.reports_payment.date).format('DD MMMM YYYY')}}
                          </template>

                          <template v-slot:cell(customers)="row">
                            <div v-if="row.item.reports_payment.customers_id">
                              <b-avatar :src="row.item.reports_payment.customer.image"
                                        v-if="row.item.reports_payment.customer.image">
                              </b-avatar>
                              <b-avatar v-else icon="building" variant="dark"></b-avatar>
                              &nbsp;<b>{{row.item.reports_payment.customer.name}}</b>
                              <b-icon icon="circle-fill" v-if="!row.item.reports_payment.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                              <b-icon v-if="row.item.reports_payment.observations"
                                      icon="chat-left-text-fill"
                                      class="ml-2 text-info"
                                      style="font-size:13px; cursor:pointer;"
                                      v-b-tooltip.hover
                                      :title="row.item.reports_payment.observations" />
                            </div>
                          </template>

                          <template v-slot:cell(efectivo)="row">
                            <span v-if="getItemAmount(row.item.reports_payment, 'Efectivo') > 0" class="text-success font-weight-bold">
                              $ {{ formatMoney(getItemAmount(row.item.reports_payment, 'Efectivo')) }}
                            </span>
                            <span v-else class="text-muted">—</span>
                          </template>

                          <template v-slot:cell(cheque)="row">
                            <span v-if="getItemAmount(row.item.reports_payment, 'Cheque') > 0" class="font-weight-bold">
                              $ {{ formatMoney(getItemAmount(row.item.reports_payment, 'Cheque')) }}
                              <span :id="'pop-cheq-sel-' + row.item.reports_payment.id">
                                <b-icon icon="info-circle-fill" class="ml-1 text-secondary" style="font-size:12px; cursor:pointer;"></b-icon>
                              </span>
                              <b-popover :target="'pop-cheq-sel-' + row.item.reports_payment.id" triggers="hover" placement="left">
                                <template #title>Info Cheque(s)</template>
                                <div v-for="(cheq, idx) in row.item.reports_payment.items.filter(i => i.type === 'Cheque')" :key="idx">
                                  <table style="font-size:12px;">
                                    <tr v-if="cheq.check_type"><td class="font-weight-bold pr-2">Tipo</td><td>{{cheq.check_type.toUpperCase()}}</td></tr>
                                    <tr v-if="cheq.check_bank"><td class="font-weight-bold pr-2">Banco</td><td>{{cheq.check_bank}}</td></tr>
                                    <tr v-if="cheq.check_number"><td class="font-weight-bold pr-2">Número</td><td>{{cheq.check_number}}</td></tr>
                                    <tr v-if="cheq.check_date_movement"><td class="font-weight-bold pr-2">Fecha</td><td>{{moment(cheq.check_date_movement).format('DD/MM/YYYY')}}</td></tr>
                                    <tr v-if="cheq.check_cuit"><td class="font-weight-bold pr-2">CUIT</td><td>{{cheq.check_cuit}}</td></tr>
                                    <tr v-if="cheq.check_observations"><td class="font-weight-bold pr-2">Obs.</td><td>{{cheq.check_observations}}</td></tr>
                                    <tr><td class="font-weight-bold pr-2">Importe</td><td>$ {{formatMoney(cheq.amount)}}</td></tr>
                                  </table>
                                  <hr v-if="idx < row.item.reports_payment.items.filter(i => i.type === 'Cheque').length - 1" class="my-1">
                                </div>
                              </b-popover>
                            </span>
                            <span v-else class="text-muted">—</span>
                          </template>

                          <template v-slot:cell(amount)="row">
                            $ {{ formatMoney(row.item.reports_payment.amounts_items) }}
                          </template>

                          <template v-slot:cell(f_action)="data">
                            <div class="text-right">
                              <b-button size="sm" variant="outline-secondary" @click="seeDetail(data.item)">
                                <i class="fa fa-list"></i> Ver detalle
                              </b-button>
                            </div>
                          </template>

                        </b-table>
                        <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(date)="data">
                  {{moment(data.item.date).format('DD MMMM YYYY')}}
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length > 50" :title="data.item.observations">
                      <b-icon icon="card-text" class="mr-1" style="font-size:17px;"></b-icon>
                      {{data.item.observations.substr(0, 50)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(status)="data">
                  <div class="text-center">
                    <b-badge v-if="data.item.status=='Pendiente'" variant="warning" class="report-payment-surrender-badge-seller">Pendiente</b-badge>
                    <b-badge v-if="data.item.status=='Revisar'" variant="danger" class="report-payment-surrender-badge-seller">
                      <b-icon icon="exclamation-circle-fill" class="mr-1"></b-icon>Revisar
                    </b-badge>
                    <b-badge v-if="data.item.status=='Aprobado'" variant="success" class="report-payment-surrender-badge-seller">Aprobado</b-badge>
                  </div>
                </template>

                <template v-slot:cell(efectivo_total)="data">
                  <span class="text-nowrap text-success font-weight-bold">
                    $ {{ formatMoney(data.item.detail ? data.item.detail.reduce(function(sum, d) { return sum + getItemAmount(d.reports_payment, 'Efectivo') }, 0) : 0) }}
                  </span>
                </template>

                <template v-slot:cell(cheque_total)="data">
                  <span class="text-nowrap font-weight-bold">
                    $ {{ formatMoney(data.item.detail ? data.item.detail.reduce(function(sum, d) { return sum + getItemAmount(d.reports_payment, 'Cheque') }, 0) : 0) }}
                  </span>
                </template>

                <template v-slot:cell(total)="data">
                  <strong class="text-nowrap">
                    $ {{ formatMoney(data.item.detail ? data.item.detail.reduce(function(sum, d) { return sum + parseFloat(d.reports_payment.amounts_items || 0) }, 0) : 0) }}
                  </strong>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="sendPrinterOrder(data.item)">
                      <b-icon icon="printer"></b-icon> Imprimir
                    </b-dropdown-item>

                    <b-dropdown-item v-if="data.item.status === 'Revisar'"
                                     @click="goToEdit(data.item)">
                      <b-icon icon="pencil-square" style="color:orange"></b-icon> Revisar rendición
                    </b-dropdown-item>

                    <b-dropdown-divider v-if="data.item.status !== 'Aprobado'"></b-dropdown-divider>
                    <b-dropdown-item v-if="data.item.status !== 'Aprobado'"
                                     @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>
        </b-row>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id"
              :reference="crud.print.reference"
              :registerID="crud.print.id"
              :key="crud.print.key"/>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import Storage from '@/handler/storageSession'
  import Printer from '@/components/inc/printer/printer'

  export default {
    components: {
      Printer
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INFORME_COBRANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudSurrenderSeller',
          elements: {}
        },
        table: {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:'align-middle'},
            {key: 'date', label: 'Fecha', class:'align-middle'},
            {key: 'observations', label: 'Observaciones', class:'align-middle'},
            {key: 'status', label: 'Estado', class: 'align-middle text-center'},
            {key: 'efectivo_total', label: 'Efectivo', class: 'align-middle text-right'},
            {key: 'cheque_total', label: 'Cheque', class: 'align-middle text-right'},
            {key: 'total', label: 'Total', class:'align-middle text-right'},
            {key: 'f_action', label:'', class:'align-middle'},
          ],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 50,
        },
        tableSub: {
          items: [],
          fields: [
            {key: 'id', label: 'Nº', sortable: true, class:'align-middle'},
            {key: 'date', label: 'Fecha', class:'align-middle'},
            {key: 'customers', label: 'Cliente', class:'align-middle'},
            {key: 'efectivo', label: 'Efectivo', class:'align-middle text-right'},
            {key: 'cheque', label: 'Cheque', class:'align-middle text-right'},
            {key: 'amount', label: 'Total', class:'align-middle text-right'},
            {key: 'f_action', label:'', class:'align-middle text-right'},
          ],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          print: {
            reference: 'reports-payment-surrender',
            id: 0,
            key: 0,
          }
        },
        arr: {
          surrender: [],
          filter: {
            status: [
              {code:'Pendiente', label: 'Pendiente'},
              {code:'Revisar', label: 'Revisar'},
              {code:'Aprobado', label: 'Aprobado'},
            ]
          },
        },
        filter: {
          date_start: '',
          date_end: '',
          sellers: [],
          status: [],
        }
      }
    },
    computed: {
      formartedItems() {
        if (!this.table.items) return []
        return this.table.items.map(item => {
          item._rowVariant = item.status === 'Revisar' ? 'danger' : ''
          return item
        })
      },
    },
    created() {
      Helper.hasAccessView(this.access)
    },
    mounted() {
      this.filterLoad()
      this.filterReport()
    },
    methods: {
      getRowCount(items) {
        return items.length
      },
      onRowSelected(item) {
        this.arr.surrender.forEach((element, index) => {
          if (item.length) {
            if (element.id == item[0].id) {
              this.openDetail(index)
            }
          }
        })
      },
      openDetail(index) {
        this.table.rowSelected = index
        this.filterReport()
      },
      remove(item) {
        const itemId = item.id
        const itemDate = moment(item.date).format('DD MMMM YYYY')
        const seller = item.seller ? item.seller.staff.name : ''

        this.$bvModal.msgBoxConfirm('¿Desea borrar la rendición Nº: (' + itemId + ') con fecha ' + itemDate + '?', {
          title: 'Borrar Registro',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show()
            var result = serviceAPI.eliminarSurrender(itemId)
            result.then(() => {
              loader.hide()
              this.filterReport()
              this.$awn.success('Registro eliminado')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      filterLoad() {
        this.filter.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.filter.date_end = moment().format('YYYY-MM-DD')
        this.restoreFilterStorage()
      },
      filterReport() {
        let loader = this.$loading.show()

        this.filter.sellers = []
        this.filter.sellers.push({
          code: Helper.getSeller().id,
          label: Helper.getSeller().name,
        })

        var result = serviceAPI.filtrarReportSurrender(this.filter)
        result.then((response) => {
          loader.hide()
          var data = response.data
          this.table.items = data
          this.arr.surrender = data

          if (this.table.rowSelected != null) {
            this.table.items[this.table.rowSelected]._showDetails = true
            if (this.table.items[this.table.rowSelected].detail) {
              this.tableSub.items = this.table.items[this.table.rowSelected].detail
            }
          }
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },

      getItemAmount(reportsPayment, type) {
        if (!reportsPayment || !reportsPayment.items) return 0
        return reportsPayment.items
          .filter(i => i.type === type)
          .reduce((sum, i) => sum + parseFloat(i.amount || 0), 0)
      },

      goToEdit(item) {
        this.$router.push({
          name: 'ReportsPaymentStaffMobileSurrenderEdit',
          params: { surrenderId: item.id }
        })
      },

      saveFilterStorage() {
        Storage.setValue('filter_report_seller_payment_surrender', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if (Storage.getValue('filter_report_seller_payment_surrender')) {
          this.filter = JSON.parse(Storage.getValue('filter_report_seller_payment_surrender'))
        }
      },

      formatMoney(value) {
        var n = parseFloat(value || 0)
        return n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
      seeDetail(item) {
        this.saveFilterStorage()
        this.$router.push({ name: 'ReportsPaymentStaffDetailReport', params: {reportID: item.reports_payment_id} })
      },
      sendPrinterOrder(item) {
        this.crud.print.key = Math.random()
        this.crud.print.id = item.id
      }
    }
  }
</script>

<style>
  .report-payment-surrender-badge-seller {
    font-size: 13px;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
